<ejs-documenteditorcontainer
  #documenteditor_default
  [showPropertiesPane]="false"
  [enableToolbar]="false"
  [locale]="culture"
  (created)="onCreate()"
  (documentChange)="onDocumentChange()"
  height="600px"
  [serviceUrl]="hostUrl"
  style="display:block;">
</ejs-documenteditorcontainer>